var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('b-icon',{staticClass:"has-margin-right-25",attrs:{"icon":_vm.icon.icon,"type":_vm.icon.type,"pack":_vm.icon.pack,"size":"is-small"}}),_c('span',{domProps:{"textContent":_vm._s(_vm.event.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }